import React from "react";
import { default as MuiTableContainer } from "@mui/material/TableContainer";

const TableContainer = (props) => {
  return <MuiTableContainer {...props} />;
};

export default TableContainer;
